'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ApplicationLayout = function (_React$Component) {
	_inherits(ApplicationLayout, _React$Component);

	function ApplicationLayout(props) {
		_classCallCheck(this, ApplicationLayout);

		var _this = _possibleConstructorReturn(this, (ApplicationLayout.__proto__ || Object.getPrototypeOf(ApplicationLayout)).call(this, props));

		_axwayReactIntl2.default.init(_this);
		return _this;
	}

	_createClass(ApplicationLayout, [{
		key: 'render',
		value: function render() {
			var hasHeader = this.props.hasHeader;

			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)('application-layout', { 'has-header': hasHeader }) },
				_react2.default.createElement(
					'div',
					{ className: 'nav-skip' },
					_react2.default.createElement(
						'a',
						{ href: '#content' },
						this.intl.formatMsg('Skip to content')
					)
				),
				this.props.children
			);
		}
	}]);

	return ApplicationLayout;
}(_react2.default.Component);

ApplicationLayout.propTypes = {
	hasHeader: _propTypes2.default.bool
};

var Content = function Content(_ref) {
	var children = _ref.children;
	return _react2.default.createElement(
		'div',
		{ className: 'contentarea', role: 'main' },
		_react2.default.createElement(
			'div',
			{ id: 'content' },
			children
		)
	);
};

var Navigation = function Navigation(_ref2) {
	var children = _ref2.children;

	return _react2.default.createElement(
		'div',
		{ className: 'application-nav' },
		children
	);
};

Navigation.propTypes = {
	nav: _propTypes2.default.node
};

Navigation.defaultProps = {
	nav: null
};

Navigation.contextTypes = {
	navVisible: _propTypes2.default.bool
};

var IntlApplicationLayout = (0, _reactIntl.injectIntl)(ApplicationLayout);
IntlApplicationLayout.Content = Content;
IntlApplicationLayout.Navigation = Navigation;

var _default = IntlApplicationLayout;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(ApplicationLayout, 'ApplicationLayout', 'src/components/ApplicationLayout.jsx');

	__REACT_HOT_LOADER__.register(Content, 'Content', 'src/components/ApplicationLayout.jsx');

	__REACT_HOT_LOADER__.register(Navigation, 'Navigation', 'src/components/ApplicationLayout.jsx');

	__REACT_HOT_LOADER__.register(IntlApplicationLayout, 'IntlApplicationLayout', 'src/components/ApplicationLayout.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/ApplicationLayout.jsx');
}();

;